import React, { memo } from 'react';
import PropTypes from 'prop-types';
import InputCurrency from '4all-ui/components/InputCurrency';
import * as styles from './style';

const InputSave = ({
  id,
  onChange,
  onFocus,
  onSave,
  btnSaveDisabled,
  btnLabel,
  disabled,
  label,
  name,
  value,
  isBtnOpen,
}) => (
  <styles.Content open={isBtnOpen} id={id}>
    <span>{label}</span>
    <form
      onClick={e => {
        e.stopPropagation();
      }}
      onSubmit={onSave}
      method="POST"
    >
      <InputCurrency
        id={`input-input-save-${id}`}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        disabled={disabled}
      />

      <styles.ButtonSave disabled={btnSaveDisabled} type="submit" id="submit-input-save">
        {btnLabel}
      </styles.ButtonSave>
    </form>
  </styles.Content>
);

InputSave.propTypes = {
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  btnLabel: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  onSave: PropTypes.func,
  disabled: PropTypes.bool,
};

InputSave.defaultProps = {
  btnSaveDisabled: false,
};

export default memo(InputSave);



// WEBPACK FOOTER //
// ./src/components/InputSave/index.js